/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-return */
/* eslint-disable max-depth */
/* eslint-disable prefer-template */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-const */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */

import { ChangeDetectorRef, Component, DestroyRef, ElementRef, HostListener, OnInit, effect, inject, input, signal, viewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, merge } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { IAgentChipList } from '../../interfaces/IAgentChatInterface';
import { FlowAction } from '../../models/ai-agent-flow.model';
import { ChatContent, ChatMessage } from '../../models/chat.model';
import { CoolantHealthIqEvaPayload, EvaCoolantConversation, EvaCoolantMessage, EvaDciConversation, EvaDciMessage, EvaDciRequestPayload, EvaDciResponse, EvaMessageInput, EvaRequestPayload, EvaResponse, EvaV2ContextPointId, EvaV2RequestPayload, EvaV2Response } from '../../models/eva-request.model';
import { AIAgentService, EVA_FEEDBACK_IDENTIFIER_SUBTYPES, EVA_FEEDBACK_IDENTIFIER_TYPES } from '../../services/ai-agent.service';
// import { SearchData } from './../../../connectivity/_models/Connectivity';
// import { SearchResultModal } from '../../../global-search-filters/contracts/modal';
import { Router } from '@angular/router';
import { SearchInputData } from '../../constant/search-input.config';
import { LocalCacheService } from '../../services/local-cache.service';
import { getLegionellaEvaDciContext, getLegionellaResponseContent, getLegionellaSessionId } from '../../utils/legionella.util';
import { ChatFlyoutComponent } from '../flyout/chat-flyout.component';
import { ChatHistoryListComponent } from '../chat-history-list/chat-history-list.component';

import { getShellUserStore } from '../../mfe-services-adapter';
/**
 * EVA (Ecolab Virtual Assistant) AI Agent Component
 * 
 * Main chat interface component for interacting with EVA, the AI-powered virtual assistant.
 * Provides features including:
 * - Real-time text-based chat with EVA API integration
 * - Voice input support using Web Speech API
 * - Message streaming for bot responses
 * - Chat history management
 * - Context-aware conversations based on selected sites/context points
 * - Suggestion chips for common queries
 * - Feedback collection for bot responses
 * 
 * @example
 * <nalco-eva-agent></nalco-eva-agent>
 */
@Component({
  selector: 'nalco-eva-agent',
  templateUrl: './ai-agent-bot.component.html',
  styleUrl: './ai-agent-bot.component.scss',
  standalone: false
})
export class EVAAIAgentComponent implements OnInit {

  private readonly aiAgentService = inject(AIAgentService);
  readonly translate = inject(TranslateService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly localCacheService = inject(LocalCacheService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);

  /** Icon image source URL for the AI agent trigger button */
  readonly agentIconSrc = input('../../../../../assets/Icon-AI-Agent.svg');

  /** Controls visibility of the agent trigger icon button; hidden by default */
  readonly showAgentIcon = input(false);

  /**
   * Suggestion chips to show on the welcome message.
   * Pass a non-empty array to show chips; pass nothing or [] to show none.
   * The component has no built-in defaults — the parent owns them.
   */
  readonly suggestionsConfig = input<string[]>([]);

  /** Reference to the chat container DOM element for scroll management */
  readonly chatContainer = viewChild<ElementRef>('chatContainer');

  /** Reference to the chat history list component */
  readonly chatHistoryList = viewChild<ChatHistoryListComponent>('chatHistoryList');

  /** Reference to the chat flyout component */
  readonly chatFlyout = viewChild<ChatFlyoutComponent>('chatFlyout');

  /** Reference to image file input element */
  readonly imageInput = viewChild<ElementRef<HTMLInputElement>>('imageInput');

  /** Array of chat messages (user and bot) in the current conversation */
  readonly messages = signal<ChatMessage[]>([]);

  sampleMessages: ChatMessage[] = [
    {
      id: 'sample-eva-message-1',
      type: 'bot',
      timestamp: new Date(),
      content: {
        type: 'text',
        data: `<strong>Let's take a look at this critical priority</strong><br/>Here are some recommended actions you can take`
      }
    },
    {
      id: 'sample-eva-message-2',
      type: 'bot',
      timestamp: new Date(),
      content: {
        type: 'text',
        data: `I found repeated cooling tower performance variance over the last 30 days. The largest deviation appears during peak load windows.`
      }
    }
  ];
  sampleEvaSuggestions: string[] = [
    'Take me to all priorities',
    'Show me all priorities',
    'Let’s dive into the first Top Priority'
  ];
  /** Current message being typed by the user */
  currentMessage: string = '';

  /** Indicates if a bot response is currently being loaded */
  isLoading: boolean = false;

  /** Indicates if a request is currently being sent to the API */
  sendingRequest: boolean = false;

  /** Connection status with the EVA backend service */
  isConnected: boolean = true;

  /** ID of the selected context point (site/location) for contextual conversations */
  contextPointId = signal<number | null>(null);

  /** Subject for managing component lifecycle and subscription cleanup */
  private destroy$ = new Subject<void>();

  /** Subject for cancelling in-flight requests when the active chat changes */
  private cancelActiveRequest$ = new Subject<void>();

  /** Web Speech API recognition instance for voice input */
  private recognition: any;

  /** Indicates if voice recording is currently active */
  isRecording: boolean = false;

  /** Indicates if voice recognition is supported in the current browser */
  voiceSupported: boolean = false;

  /** Current microphone permission state: 'granted', 'denied', or 'prompt' */
  microphonePermission: string = 'prompt';

  /** Dynamic placeholder message for the input textarea */
  placeHolderMessage!: string;

  /** Timeout reference for voice recording management */
  private recordingTimeout: any;

  /** Minimum height for the auto-resizing textarea in pixels */
  private minTextareaHeight = 40;

  /** Maximum height for the auto-resizing textarea in pixels */
  private maxTextareaHeight = 96;

  /** Flag indicating if input validation error should be shown */
  noInput: boolean = false;

  /** Currently selected feedback data for a message */
  private feedbackSelections: Record<string, 'like' | 'dislike'> = {};

  /** Message displayed while EVA is processing a request */
  agentProcessingMessage = "Let me check that for you...";

  /** Configuration data for search input component */
  searchInputData: any;

  /** ID of the message currently being edited, null if no edit in progress */
  editMessageId: string | null = null;

  /** Content of the message being edited */
  editingMessage: string = '';

  /** Controls visibility of the AI agent flyout panel */
  showAIAgent = false;

  /** Tracks whether the EVA flyout is in collapsed state */
  private isEvaCollapsed = false;

  /** Details of the currently selected search result (site/location) */
  selectedSearchDetails: any = { name: null };

  /** Current chat session ID for conversation continuity */
  chatID: string | null = null;

  /** Cache for context point details to avoid redundant API calls */
  private contextPointCache: { [contextPointId: string]: { contextPointId: number, siteName: string } } = {};

  /** Indicates if a chat history is currently being loaded */
  isLoadingChat = signal<boolean>(false);

  /** Controls whether bot message streaming is enabled */
  enableChatStreaming = false;

  /** Search result modal data */
  searchResultModal: any;

  /** Active suggestion chips to display for user quick actions */
  activeSuggestions: string[] | null = null;

  private readonly mobileBreakpoint = 720;

  private isMobile = this.checkIsMobile();

  flyOutWidthPercentage = signal<number>(this.isMobile ? 100 : 26.5);

  @HostListener('window:resize')
  onWindowResize(): void {
    const wasMobile = this.isMobile;
    this.isMobile = this.checkIsMobile();
    if (wasMobile !== this.isMobile) {
      this.flyOutWidthPercentage.set(this.isMobile ? 100 : 26.5);
    }
  }

  private pendingPromptPrefixFeedback: 'helpful' | 'not-helpful' | null = null;

  /** Unique identifier for the welcome message to control suggestion display */
  private welcomeMessageId: string = 'welcome-message-id';
  currentPlaceholder = 'How can I help you?';
  
  /**
   * Suggestions baked into the welcome message.
   * Sourced from `EvaState.suggestions` when non-empty; otherwise the
   * `suggestionsConfig` input; empty when both are empty (no chips shown).
   */
  private resolvedInitialSuggestions: string[] = [];

  private activeFlowAction: FlowAction = 'none';

  private pendingSourcePatch: {
    subType?: string;
    scope?: string;
    comment?: string;
  } | null = null;


  constructor() {
    // Reactively sync contextPointId from the service signal.
    // When UserSettings becomes available in sessionStorage, the service
    // updates its signal and this effect picks it up automatically.
    effect(() => {
      const id = this.aiAgentService.defaultCorporateId();
      if (id && !this.contextPointId()) {
        this.contextPointId.set(id);
      }
    });

    // Register cleanup on destroy
    this.destroyRef.onDestroy(() => {
      this.cancelActiveRequest$.next();
      this.cancelActiveRequest$.complete();
      this.destroy$.next();
      this.destroy$.complete();

      // Clean up speech recognition
      if (this.recognition && this.isRecording) {
        this.isRecording = false;
        this.recognition.stop();
      }

      // Clear any pending timeouts
      if (this.recordingTimeout) {
        clearTimeout(this.recordingTimeout);
      }

      // Clear context point cache on component destroy
      this.clearContextPointCache();
    });
  }

  /**
   * Component initialization lifecycle hook
   * Sets up initial state, voice recognition, and loads the welcome message
   */
  ngOnInit() {
    // Seed from the input synchronously so `initializeChat` sees a value even
    // if translations resolve immediately below. The state subscription later
    // in this hook will override this if `EvaState.suggestions` is non-empty.
    this.resolvedInitialSuggestions = this.suggestionsConfig() ?? [];

    this.translate.use('en').pipe(take(1)).subscribe(() => {
      this.initializeChat();
    });
    this.placeHolderMessage = 'Ask me anything..!';
    this.chatID = null;
    //   this.chipList = [
    //   { name: 'Water Quality overview', value: 'Give details about water quality?', iconUrl: '' },
    // ]
    this.searchInputData = JSON.parse(JSON.stringify(SearchInputData))
    this.setupVoiceRecognition();
    this.checkMicrophonePermission();
    this.aiAgentService.getContextPointId$()
      .pipe(takeUntil(this.destroy$))
      .subscribe(id => {
        this.contextPointId.set(id);
      });

    // Subscribe to EVA state changes to handle external prompts
    this.aiAgentService.getEvaState$()
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        // State-supplied suggestions win over the input; must be set BEFORE
        // startNewChat below, since that path re-runs initializeChat and
        // bakes these into the welcome message.
        this.resolvedInitialSuggestions = state.suggestions?.length
          ? state.suggestions
          : (this.suggestionsConfig() ?? []);

        if (state.newChat) {
          this.startNewChat();
        }
        if (state.prompt && state.prompt.trim()) {
          this.pendingPromptPrefixFeedback = state.promptPrefixFeedback ?? null;
          this.currentMessage = state.prompt;
          this.sendMessage();
        } else {
          this.pendingPromptPrefixFeedback = null;
        }
        if (typeof state.show === 'boolean' && state.show) {
          this.showAIAgent = true;
          this.isEvaCollapsed = state.collapsed ?? false;
          if (typeof state.collapsed === 'boolean' && state.collapsed) {
            this.flyOutWidthPercentage.set(1);
          } else if (typeof state.collapsed === 'boolean' && !state.collapsed) {
            this.flyOutWidthPercentage.set(this.isMobile ? 100 : 26.5);
          }
        } else if (typeof state.show === 'boolean' && !state.show) {
          this.showAIAgent = false;
          this.isEvaCollapsed = false;
        }
        window.dispatchEvent(new CustomEvent('eva-mfe-state', { detail: { open: this.showAIAgent, collapsed: state.collapsed ?? false } }));
      });

    this.aiAgentService.botFlow$
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {

        if (event.source !== 'bot') return;

        if (event.type === 'start') {
          this.activeFlowAction = event.action;

          if (event.promptPrefixFeedback) {
            this.pendingPromptPrefixFeedback = event.promptPrefixFeedback;
          }

          this.addUserMessage(event.userText);
          this.addBotMessage(event.botText, event.chips ?? []);

          if (event.waitForUser === false) {
            this.activeFlowAction = 'none';
            this.resetFlowSourceIdentifier();
          }

          return;
        }

        if (event.type === 'message') {
          this.addBotMessage(event.text, event.chips ?? []);
          if (event.waitForUser) {
          } else {
            this.activeFlowAction = 'none';
            this.resetFlowSourceIdentifier();
          }

          return;
        }

        if (event.type === 'call-api') {
          this.pendingSourcePatch = event.sourcePatch ?? null;
          this.callApiOnly(event.text, event.sourcePatch, event.silent, event.action);
          return;
        }
      });
  }
  private resetFlowSourceIdentifier(): void {
    const details = this.aiAgentService.nextPromtDetails;
    const sourceIdentifier = details?.activeContext?.sourceIdentifier;
    if (sourceIdentifier) {
      details!.activeContext!.sourceIdentifier = {
        ...sourceIdentifier,
        subType: '',
        scope: '',
        comment: ''
      };
    }
  }

  private callApiOnly(messageToSend: string,
    sourcePatch?: {
      subType?: string;
      scope?: string;
      comment?: string;
    },
    silent?: boolean,
    flowAction?: FlowAction
  ): void {

    if (sourcePatch) {
      const existingContext = this.aiAgentService.nextPromtDetails?.activeContext;
      const nextPromptDetails = this.aiAgentService.nextPromtDetails;

      if (nextPromptDetails?.activeContext?.sourceIdentifier) {
        nextPromptDetails.activeContext = {
          ...nextPromptDetails.activeContext,
          sourceIdentifier: {
            ...nextPromptDetails.activeContext.sourceIdentifier,
            ...sourcePatch
          }
        };
      }
    }

    // Add user message to chat if text is provided and not silent
    if (messageToSend?.trim() && !silent) {
      const userMessage: ChatMessage = {
        id: this.generateId(),
        type: 'user',
        timestamp: new Date(),
        content: {
          type: 'text',
          data: messageToSend.trim()
        }
      };

      this.messages.update(msgs => [...msgs, userMessage]);
      this.scrollToBottom();
    }

    this.sendingRequest = true;

    if (!silent) {
      this.isLoading = true;
    }

    if (this.router.url.includes('food-and-beverage')) {
      this.getEvaResponse(silent);
    } else {
      this.getEvaV2Response(silent, flowAction);
    }
  }

  getEvaV2Response(silent: boolean | undefined, flowAction: FlowAction | undefined) {
    const payload = this.buildEvaV2RequestPayload();

    this.aiAgentService.getEVAResponseV2(payload)
      .pipe(takeUntil(merge(this.destroy$, this.cancelActiveRequest$)))
      .subscribe(
        (response: EvaV2Response | null) => {
          const res = response as any;
          this.chatID = res?.chatId ?? res?.ChatId ?? this.chatID;

          if (!silent) {
            const parsedResponse = this.parseV2Response(response);
            const botMessage: ChatMessage = {
              id: this.generateId(),
              type: 'bot',
              timestamp: new Date(),
              content: {
                ...parsedResponse,
                metadata: {
                  ...(parsedResponse.metadata ?? {}),
                  chatId: res?.chatId ?? res?.ChatId ?? this.chatID ?? undefined
                }
              }
            };
            this.messages.update(msgs => [...msgs, botMessage]);
            this.scrollToBottom();

            const suggestedPrompts = res?.suggestedPrompts ?? res?.SuggestedPrompts;
            if (suggestedPrompts?.length) {
              this.activeSuggestions = suggestedPrompts;
            }
          }

          this.isLoading = false;
          this.sendingRequest = false;
          this.resetFlowSourceIdentifier();
          if (flowAction) {
            this.aiAgentService.emitBotFlow({
              source: 'bot',
              type: 'api-result',
              action: flowAction,
              success: response !== null
            });
          }
        },
        () => {

          if (!silent) {
            const errorMessage: ChatMessage = {
              id: this.generateId(),
              type: 'bot',
              timestamp: new Date(),
              content: {
                type: 'text',
                data: 'Sorry, I encountered an error while processing your request. Please try again.'
              }
            };

            this.messages.update(msgs => [...msgs, errorMessage]);
            this.scrollToBottom();
          }

          this.isLoading = false;
          this.sendingRequest = false;
          this.resetFlowSourceIdentifier();

          if (flowAction) {
            this.aiAgentService.emitBotFlow({
              source: 'bot',
              type: 'api-result',
              action: flowAction,
              success: false
            });
          }
        }
      );
  }
  getEvaResponse(silent: boolean | undefined) {
    const payload = this.buildEvaRequestPayload();

    this.aiAgentService.getEVAResponse(payload)
      .pipe(takeUntil(merge(this.destroy$, this.cancelActiveRequest$)))
      .subscribe(
        (response: EvaResponse | null) => {
          this.chatID = response?.ChatId ?? this.chatID;
          if (!silent) {
            const parsedResponse = this.parseResponse(response);
            const botMessage: ChatMessage = {
              id: this.generateId(),
              type: 'bot',
              timestamp: new Date(),
              content: {
                ...parsedResponse,
                metadata: this.buildResponseMetadata(response, parsedResponse)
              }
            };
            this.messages.update(msgs => [...msgs, botMessage]);
            this.scrollToBottom();
          }
          this.isLoading = false;
          this.sendingRequest = false;
          this.resetFlowSourceIdentifier();
        },
        () => {
          if (!silent) {
            const errorMessage: ChatMessage = {
              id: this.generateId(),
              type: 'bot',
              timestamp: new Date(),
              content: {
                type: 'text',
                data: 'Sorry, I encountered an error while processing your request. Please try again.'
              }
            };
            this.messages.update(msgs => [...msgs, errorMessage]);
            this.scrollToBottom();
          }
          this.isLoading = false;
          this.sendingRequest = false;
          this.resetFlowSourceIdentifier();
        }
      );
  }



  /**
   * Initialize chat with welcome message and suggestion chips
   * Generates personalized greeting based on time of day and user's name
   * @private
   */
  private initializeChat() {
    this.resetActiveRequestState();

    // Add welcome message
    this.messages.set([]);
    this.chatID = null;
    let name = (getShellUserStore()?.userDetails() as any)?.['firstName'];
    let greeting = this.getTimeBasedGreeting();
    if (!this.router.url.includes('food-and-beverage')) {
      name = this.getFirstNameFromSession();
    }
    const welcomeMessage: ChatMessage = {
      id: this.welcomeMessageId,
      type: 'bot',
      timestamp: new Date(),
      content: {
        type: 'text',
        data: `<strong>${greeting},${name ? ' ' + name : ''}</strong>! ${this.translate.instant('AI_AGENT.AGENT_WELCOME_MESSAGE')} <br/> <span style="color: #313233">${this.translate.instant('AI_AGENT.HELP_QUESTION')}</span>`,
        // Bake the initial suggestions into the message itself so API responses
        // can never overwrite them via the shared activeSuggestions field.
        metadata: { welcomeChips: this.resolvedInitialSuggestions }
      }
    };
    this.messages.update(msgs => [...msgs, welcomeMessage]);
    this.scrollToBottom();
  }

  /**
   * Send user message to EVA API and process response
   * Handles message validation, API communication, and error scenarios
   * 
   * @param editMessageId - Optional ID for editing an existing message
   */
  sendMessage(editMessageId?: string) {
    this.scrollToBottom();
    this.noInput = !this.currentMessage?.trim().length;
    this.enableChatStreaming = true;

    if (!this.currentMessage?.trim() || this.isLoading) {
      this.currentMessage = '';
      return;
    }

    const messageToSend = this.currentMessage.trim();

    if (this.activeFlowAction && this.activeFlowAction !== 'none') {
      const userMessage: ChatMessage = {
        id: editMessageId ? editMessageId : this.generateId(),
        type: 'user',
        timestamp: new Date(),
        content: {
          type: 'text',
          data: messageToSend
        }
      };

      this.messages.update(msgs => [...msgs, userMessage]);
      this.currentMessage = '';
      this.scrollToBottom();

      this.aiAgentService.emitBotFlow({
        source: 'user',
        type: 'text',
        action: this.activeFlowAction,
        text: messageToSend
      });

      return;
    }
    this.sendingRequest = true;

    const userMessage: ChatMessage = {
      id: editMessageId ? editMessageId : this.generateId(),
      type: 'user',
      timestamp: new Date(),
      content: {
        type: 'text',
        data: messageToSend,
        metadata: this.pendingPromptPrefixFeedback
          ? { promptPrefixFeedback: this.pendingPromptPrefixFeedback }
          : undefined
      }
    };

    this.messages.update(msgs => [...msgs, userMessage]);
    this.pendingPromptPrefixFeedback = null;
    this.scrollToBottom();
    this.currentMessage = '';
    this.isLoading = true;

    setTimeout(() => {
      const textarea = document.getElementById('ask-label') as HTMLTextAreaElement;
      if (textarea) {
        textarea.style.height = this.minTextareaHeight + 'px';
      }
    }, 0);

    // DCI (Legionella Dashboard, Coolant Health IQ) specific flow.
    // This is a temporary solution until the API is unified.
    if (this.isLegionellaTestResultsRoute()) {
      this.getLegionellaSpecificEvaResponse();
      return;
    }

    if (this.isCoolantHealthIqRoute()) {
      this.getCoolantHealthIqSpecificEvaResponse();
      return;
    }
    // End DCI (Legionella Dashboard, Coolant Health IQ) specific flow.


    if (this.router.url.includes('food-and-beverage')) {
      this.getEvaMessage();
    } else {
      this.getEvaV2Message();
    }
  }

  getEvaV2Message() {
    const payload = this.buildEvaV2RequestPayload();

    this.aiAgentService.getEVAResponseV2(payload)
      .pipe(takeUntil(merge(this.destroy$, this.cancelActiveRequest$)))
      .subscribe(
        (response: EvaV2Response | null) => {
          const res = response as any;
          this.chatID = res?.chatId ?? res?.ChatId ?? this.chatID;
          const parsedResponse = this.parseV2Response(response);
          const responseMessageId = this.generateId();
          const botMessage: ChatMessage = {
            id: responseMessageId,
            type: 'bot',
            timestamp: new Date(),
            content: {
              ...parsedResponse,
              metadata: {
                ...(parsedResponse.metadata ?? {}),
                chatId: res?.chatId ?? res?.ChatId ?? this.chatID ?? undefined
              }
            }
          };

          this.messages.update(msgs => [...msgs, botMessage]);
          const suggestedPrompts = res?.suggestedPrompts ?? res?.SuggestedPrompts;
          if (suggestedPrompts?.length) {
            this.activeSuggestions = suggestedPrompts;
          }
          this.isLoading = false;
          this.sendingRequest = false;
          this.pendingSourcePatch = null;
          this.activeFlowAction = 'none';

          this.scrollToBottom();
        },
        (_error: any) => {

          const errorMessage: ChatMessage = {
            id: this.generateId(),
            type: 'bot',
            timestamp: new Date(),
            content: {
              type: 'text',
              data: 'Sorry, I encountered an error while processing your request. Please try again.'
            }
          };

          this.messages.update(msgs => [...msgs, errorMessage]);

          this.isLoading = false;
          this.sendingRequest = false;
          this.pendingSourcePatch = null;
          this.activeFlowAction = 'none';

          this.scrollToBottom();
        }
      );
  }

  getEvaMessage() {
    const payload = this.buildEvaRequestPayload();
    this.aiAgentService.getEVAResponse(payload)
      .pipe(takeUntil(merge(this.destroy$, this.cancelActiveRequest$)))
      .subscribe(
        (response: EvaResponse | null) => {

          this.chatID = response?.ChatId ?? this.chatID;
          const parsedResponse = this.parseResponse(response);
          const responseMessageId = this.generateId();

          const botMessage: ChatMessage = {
            id: responseMessageId,
            type: 'bot',
            timestamp: new Date(),
            content: {
              ...parsedResponse,
              metadata: this.buildResponseMetadata(response, parsedResponse)
            }
          };

          this.messages.update(msgs => [...msgs, botMessage]);

          this.isLoading = false;
          this.sendingRequest = false;
          this.pendingSourcePatch = null;
          this.activeFlowAction = 'none';

          this.scrollToBottom();
        },
        (_error: any) => {

          const errorMessage: ChatMessage = {
            id: this.generateId(),
            type: 'bot',
            timestamp: new Date(),
            content: {
              type: 'text',
              data: 'Sorry, I encountered an error while processing your request. Please try again.'
            }
          };

          this.messages.update(msgs => [...msgs, errorMessage]);

          this.isLoading = false;
          this.sendingRequest = false;
          this.pendingSourcePatch = null;
          this.activeFlowAction = 'none';

          this.scrollToBottom();
        }
      );
  }

  /**
  * Handle dismiss and close actions for EVA
  * @param actionType - The type of action to handle ('dismiss' or 'close')
  */

  private addUserMessage(text: string): void {
    this.messages.update(msgs => [
      ...msgs,
      {
        id: this.generateId(),
        type: 'user',
        timestamp: new Date(),
        content: {
          type: 'text',
          data: text,
          metadata: this.pendingPromptPrefixFeedback
            ? { promptPrefixFeedback: this.pendingPromptPrefixFeedback }
            : undefined
        }
      }
    ]);
    this.pendingPromptPrefixFeedback = null;
  }

  private addBotMessage(text: string, chips: IAgentChipList[] = []): void {
    const fallbackFeedbackContext = this.getFallbackFeedbackContext();
    const metadata = {
      ...(chips.length ? { actionChips: chips } : {}),
      ...(fallbackFeedbackContext ? { feedbackContext: fallbackFeedbackContext } : {}),
      ...(this.chatID ? { chatId: this.chatID } : {})
    };
    this.messages.update(msgs => [
      ...msgs,
      {
        id: this.generateId(),
        type: 'bot',
        timestamp: new Date(),
        content: {
          type: 'text',
          data: text,
          metadata: Object.keys(metadata).length ? metadata : undefined
        }
      }
    ]);

    this.isLoading = false;
    this.sendingRequest = false;
    this.scrollToBottom();
  }

  /**
   * Handle keyboard events in the textarea
   * Manages Enter key (send message), Escape key (cancel edit), and auto-resize
   * 
   * @param event - Keyboard event from the textarea
   */
  onKeyPress(event: any) {
    if (this.isRecording) {
      this.recognition.stop();
    }

    // Handle edit mode key presses
    if (this.editMessageId) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        // this.currentMessage = event?.target?.value;
        this.saveEditedMessage();
        return;
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        this.cancelEdit();
        return;
      }
    } else {
      // Normal message input mode
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        this.sendMessage();
      }
    }

    // Auto-adjust textarea height after key press
    setTimeout(() => {
      const textarea = event.target as HTMLTextAreaElement;
      this.adjustTextareaHeight(textarea);
    }, 0);
  }

  /**
   * Handle textarea input for auto-resize and error state
   */
  onTextareaInput(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    this.adjustTextareaHeight(textarea);

    // Clear error state when user starts typing
    if (this.noInput) {
      this.noInput = false;
    }
  }

  /**
   * Auto-adjust textarea height based on content
   */
  private adjustTextareaHeight(textarea: HTMLTextAreaElement): void {
    if (!textarea) return;

    // Reset height to auto to calculate scroll height
    textarea.style.height = 'auto';

    const scrollHeight = textarea.scrollHeight;
    const newHeight = Math.min(Math.max(scrollHeight, this.minTextareaHeight), this.maxTextareaHeight);

    textarea.style.height = newHeight + 'px';

    // Show scrollbar if content exceeds max height
    if (scrollHeight > this.maxTextareaHeight) {
      textarea.style.overflowY = 'auto';
    } else {
      textarea.style.overflowY = 'hidden';
    }
  }

  /**
   * Build EVA API request payload from current message history
   * Converts chat messages to the format expected by the EVA backend
   * 
   * @returns Formatted request payload with message history and context
   * @private
   */
  private buildEvaRequestPayload(): EvaRequestPayload {
    const messages: EvaMessageInput[] = [];

    for (const message of this.messages()) {
      if (message?.content?.type !== 'text') {
        continue;
      }

      const content = this.toPlainText(message.content?.data);
      if (!content.length) {
        continue;
      }

      const role: EvaMessageInput['role'] =
        message.type === 'user' ? 'user' : 'assistant';

      messages.push({ role, content });
    }

    const nextPromptActiveContext =
      this.aiAgentService.nextPromtDetails?.activeContext;

    const mergedMessages = this.aiAgentService.nextPromtDetails?.messages
      ? [...this.aiAgentService.nextPromtDetails.messages, ...messages]
      : messages;

    const resolvedChatId =
      this.aiAgentService.nextPromtDetails?.chatId ||
      this.chatID ||
      '';

    const resolvedActiveContext = nextPromptActiveContext ?? {
      contextPoints: [],
      intelligenceid: '',
      iqName: [],
      sourceIdentifier: {
        primaryId: '',
        secondaryId: '',
        type: '',
        subType: '',
        scope: '',
        comment: '',
        dateRange: {
          start: '',
          end: '',
          duration: ''
        }
      }
    };

    const resolvedActivePageId =
      this.aiAgentService.nextPromtDetails?.activeContext?.contextPoints?.[0]?.contextPointId ||
      this.selectedSearchDetails?.Site ||
      (this.contextPointId ? String(this.contextPointId) : '');

    const resolvedAllUserSiteIds =
      this.aiAgentService.nextPromtDetails?.activeContext?.contextPoints?.length
        ? this.aiAgentService.nextPromtDetails.activeContext.contextPoints.map(cp => cp.contextPointId)
        : this.selectedSearchDetails?.Site
          ? (this.selectedSearchDetails.Site as (string | number)[]).map(String)
          : [this.contextPointId ? String(this.contextPointId) : ''].filter(Boolean);

    // Keep both payload contracts during merge period to avoid breaking either caller/backend expectation.
    const payload: EvaRequestPayload & Record<string, unknown> = {
      messages: mergedMessages,
      chatId: resolvedChatId,
      activeContext: resolvedActiveContext,
      chat_id: resolvedChatId,
      active_context: {
        ai_generated_insights_id: resolvedActiveContext.intelligenceid || ''
      },
      active_page_id: resolvedActivePageId,
      all_user_site_ids: resolvedAllUserSiteIds
    };

    return payload;
  }


  private buildEvaV2RequestPayload(): EvaV2RequestPayload {
    const v2Details = this.aiAgentService.nextPromptDetailsV2;
    const messages: EvaMessageInput[] = [];

    for (const message of this.messages()) {
      if (message?.content?.type !== 'text' && message?.content?.type !== 'markdown') {
        continue;
      }
      const content = this.toPlainText(message.content?.data);
      if (!content.length) {
        continue;
      }
      const role: EvaMessageInput['role'] = message.type === 'user' ? 'user' : 'assistant';
      messages.push({ role, content });
    }

    const isFnbiRoute = this.router.url.startsWith('/food-and-beverage-intelligence');
    const intelligenceId = v2Details?.intelligenceId ?? (isFnbiRoute ? 1 : 2);

    const contextPointIds: EvaV2ContextPointId[] = v2Details?.contextPointIds?.length
      ? v2Details.contextPointIds
      : this.aiAgentService.nextV2ContextPointIds?.length
        ? this.aiAgentService.nextV2ContextPointIds
        : this.contextPointId()
          ? [{ contextPointId: this.contextPointId(), contextPointTypeId: 5000, contextPointSubtypeId: '' }]
          : [];

    const payload: EvaV2RequestPayload = {
      messages,
      chatId: this.chatID || v2Details?.chatId || '',
      contextPointIds,
      intelligenceId
    };

    if (v2Details?.activeContext?.length) {
      payload.activeContext = v2Details.activeContext;
    }
    if (v2Details?.dateRange) {
      payload.dateRange = v2Details.dateRange;
    }

    return payload;
  }

  private parseV2Response(response: EvaV2Response | null): ChatContent {
    const res = response as any;
    const contentParts: any[] = res?.contentParts ?? res?.ContentParts ?? [];

    if (!contentParts.length) {
      return { type: 'text', data: 'Sorry, I could not parse the response. Please try again.' };
    }

    // Normalize each part into its declared type + content, dropping empties.
    // A bare string part is treated as text (back-compat with older payloads).
    const blocks = contentParts
      .map((part: any) => {
        if (typeof part === 'string') {
          return { partType: 'text', content: part };
        }
        const content = part?.content ?? part?.Content ?? '';
        const partType = String(part?.type ?? part?.Type ?? 'text').toLowerCase();
        return { partType, content };
      })
      .filter((block) => typeof block.content === 'string' && block.content.length > 0);

    if (!blocks.length) {
      return { type: 'text', data: 'Sorry, I could not parse the response. Please try again.' };
    }

    // Map a V2 part type to a ChatContent rendering type. Text renders as
    // markdown (preserving prior behaviour); html renders as raw html.
    const toChatType = (partType: string): ChatContent['type'] =>
      partType === 'html' ? 'html' : 'markdown';

    // If every part shares the same rendering type, merge them into one block.
    const chatTypes = blocks.map((block) => toChatType(block.partType));
    if (chatTypes.every((type) => type === chatTypes[0])) {
      return { type: chatTypes[0], data: blocks.map((block) => block.content).join('') };
    }

    // Otherwise preserve ordering by emitting a mixed sequence of blocks.
    return {
      type: 'mixed',
      data: {
        blocks: blocks.map((block) => ({
          type: toChatType(block.partType),
          data: block.content,
        })),
      },
    };
  }


  /**
   * Convert HTML or formatted text to plain text
   * Removes HTML tags and normalizes whitespace
   *
   * @param value - Input value to convert
   * @returns Plain text string
   * @private
   */
  private toPlainText(value: any): string {
    if (typeof value !== 'string') {
      return String(value ?? '').trim();
    }

    return value.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  /**
   * Parse EVA API response into ChatContent format
   * Handles various response structures and extracts displayable content
   * 
   * @param response - Raw response from EVA API
   * @returns Formatted chat content ready for display
   * @private
   */
  private parseResponse(response: EvaResponse | any): ChatContent {
    // Handle different response types from backend
    try {
      if (response?.Message && typeof response.Message === 'string') {
        return {
          type: 'text',
          data: response.Message || 'Sorry, I could not parse the response. Please try again.'
        };
      }

      if (typeof response.Response === 'string') {
        return { type: 'text', data: response.Response };
      }

      if (response.type) {
        return response as ChatContent;
      }

      // Auto-detect response type
      if (Array.isArray(response)) {
        return {
          type: 'list',
          data: { type: 'unordered', items: response },
          metadata: { title: 'Results' }
        };
      }

      if (typeof response === 'object') {
        // Check if it's a table structure
        if (response.headers && response.rows) {
          return {
            type: 'table',
            data: response,
            metadata: { title: response.title || 'Data Table' }
          };
        }

        // Check if it's code
        if (response.code && response.language) {
          return {
            type: 'code',
            data: response.code,
            metadata: { language: response.language }
          };
        }

        // Default to text representation
        response.choices = response.choices[0].message.content || ""
        return {
          type: 'text',
          data: JSON.stringify(response, null, 2)
        };
      }

      return { type: 'text', data: String(response) };

    } catch (error) {
      return {
        type: 'text',
        data: 'Error parsing response from server.'
      };
    }
  }

  /**
   * Generate a unique message ID
   * @returns Random alphanumeric string
   * @private
   */
  private generateId(): string {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }

  /**
   * Get time-based greeting based on current hour
   */
  private getTimeBasedGreeting(): string {
    const currentHour = new Date().getHours();

    if (currentHour >= 5 && currentHour < 12) {
      return this.translate.instant('AI_AGENT.GOOD_MORNING');
    } else if (currentHour >= 12 && currentHour < 17) {
      return this.translate.instant('AI_AGENT.GOOD_AFTERNOON');
    } else if (currentHour >= 17 && currentHour < 21) {
      return this.translate.instant('AI_AGENT.GOOD_EVENING');
    } else {
      return this.translate.instant('AI_AGENT.HELLO');
    }
  }

  private getFirstNameFromSession(): string {
    try {
      const settings = JSON.parse(sessionStorage.getItem('UserSettings') || '{}');
      return settings?.UserName
        || localStorage.getItem('ecolab.envision_User_FirstName')
        || '';
    } catch {
      return localStorage.getItem('ecolab.envision_User_FirstName') || '';
    }
  }

  private scrollToBottom(): void {
    setTimeout(() => {
      try {
        const container = this.chatContainer();
        const chatContainerEl = container?.nativeElement;
        if (chatContainerEl) {
          if (typeof chatContainerEl.scrollTo === 'function') {
            chatContainerEl.scrollTo({ top: chatContainerEl.scrollHeight, behavior: 'smooth' });
          } else {
            chatContainerEl.scrollTop = chatContainerEl.scrollHeight;
          }
        }
      } catch (err) {
        console.error('Scroll error:', err);
      }
    }, 200);
  }

  // Will be removed once API for DCI (Legionella Dashboard) is unified in BED.
  private getLegionellaSpecificEvaResponse(): void {
    const latestUserMessage = [...this.messages()]
      .reverse()
      .find(message => message.type === 'user' && message.content?.type === 'text');

    const payload: EvaDciRequestPayload = {
      Message: this.toPlainText(latestUserMessage?.content?.data || ''),
      SessionId: this.chatID
    };
    const queryParams = getLegionellaEvaDciContext();

    this.aiAgentService.getLegionellaSpecificEvaResponse(payload, queryParams)
      .pipe(takeUntil(merge(this.destroy$, this.cancelActiveRequest$)))
      .subscribe((response: EvaDciResponse | null) => {
        this.chatID = getLegionellaSessionId(response) ?? this.chatID;

        const botMessage: ChatMessage = {
          id: response?.MessageId || this.generateId(),
          type: 'bot',
          timestamp: new Date(),
          content: getLegionellaResponseContent(response)
        };

        this.messages.update(msgs => [...msgs, botMessage]);
        this.isLoading = false;
        this.sendingRequest = false;
        this.scrollToBottom();
      },
        (_error: any) => {
          const errorMessage: ChatMessage = {
            id: this.generateId(),
            type: 'bot',
            timestamp: new Date(),
            content: {
              type: 'text',
              data: 'Sorry, I encountered an error while processing your request. Please try again.'
            }
          };

          this.messages.update(msgs => [...msgs, errorMessage]);
          this.isLoading = false;
          this.sendingRequest = false;
          this.scrollToBottom();
        }
      );
  }

  // Will be removed once API for DCI (Legionella Dashboard) is unified in BED.
  private isLegionellaTestResultsRoute(): boolean {
    return this.router.url.includes('/legionella-test-results');
  }

  private isCoolantHealthIqRoute(): boolean {
    return this.router.url.includes('/coolant-health-iq');
  }

  // Get Coolant Health IQ specific EVA response. This is a temporary solution until the API is unified.
  private getCoolantHealthIqSpecificEvaResponse(): void {
    const ctx = this.aiAgentService.coolantHealthIqEvaContext;
    const latestUserMessage = [...this.messages()]
      .reverse()
      .find(message => message.type === 'user' && message.content?.type === 'text');

    const payload: CoolantHealthIqEvaPayload = {
      messages: [{ role: 'user', content: this.toPlainText(latestUserMessage?.content?.data || '') }],
      activeContext: ctx
        ? [{ id: String(ctx.contextPointId), type: ctx.contextPointTypeId === 5000 ? 'Site' : 'Corporate' }]
        : [],
      contextPointIds: ctx
        ? [{ contextPointId: ctx.contextPointId, contextPointTypeId: ctx.contextPointTypeId }]
        : [],
      dateRange: ctx
        ? { start: ctx.startDate, end: ctx.endDate }
        : { start: '', end: '' },
      ...(this.chatID ? { chatId: this.chatID } : {})
    };

    this.aiAgentService.getCoolantHealthIqEvaResponse(payload)
      .pipe(takeUntil(merge(this.destroy$, this.cancelActiveRequest$)))
      .subscribe({
        next: (response: EvaV2Response | null) => {
          const res = response as any;
          this.chatID = res?.chatId ?? res?.ChatId ?? this.chatID;

          const contentPartsText: string = (res?.contentParts ?? res?.ContentParts ?? [])
            .map((part: any) => part?.content ?? part?.Content ?? '')
            .filter((text: string) => text.length > 0)
            .join('');

          const botMessage: ChatMessage = {
            id: res?.messageId ?? res?.MessageId ?? this.generateId(),
            type: 'bot',
            timestamp: new Date(),
            content: getLegionellaResponseContent({ Message: contentPartsText })
          };

          this.messages.update(msgs => [...msgs, botMessage]);
          this.isLoading = false;
          this.sendingRequest = false;
          this.scrollToBottom();
        },
        error: () => {
          const errorMessage: ChatMessage = {
            id: this.generateId(),
            type: 'bot',
            timestamp: new Date(),
            content: {
              type: 'text',
              data: 'Sorry, I encountered an error while processing your request. Please try again.'
            }
          };

          this.messages.update(msgs => [...msgs, errorMessage]);
          this.isLoading = false;
          this.sendingRequest = false;
          this.scrollToBottom();
        }
      });
  }

  // Utility methods for template

  /**
   * Check if a message is from the user
   * @param message - Chat message to check
   * @returns True if message is from user
   */
  isUserMessage(message: ChatMessage): boolean {
    return message.type === 'user';
  }

  /**
   * Check if a message is from the bot
   * @param message - Chat message to check
   * @returns True if message is from bot
   */
  isBotMessage(message: ChatMessage): boolean {
    return message.type === 'bot';
  }

  getUserMessagePrefixIconPath(message: ChatMessage): string | null {
    const promptPrefixFeedback = message.content?.metadata?.promptPrefixFeedback;

    if (promptPrefixFeedback === 'helpful') {
      return 'assets/images/thumbs-up-blue.svg';
    }

    if (promptPrefixFeedback === 'not-helpful') {
      return 'assets/images/thumbs-down-blue.svg';
    }

    return null;
  }

  /**
   * Track by function for ngFor optimization
   * @param index - Index in the messages array
   * @param message - Message object
   * @returns Unique message ID for tracking
   */
  trackByMessageId(index: number, message: ChatMessage): string {
    return message.id;
  }

  /**
   * Get suggestion chips for a specific message
   * Only returns suggestions for the welcome message
   * 
   * @param message - Chat message to check
   * @returns Array of suggestion strings or empty array
   */
  getEvaSuggestions(message: ChatMessage): string[] {
    const chips = message.content?.metadata?.actionChips;
    if (chips?.length) {
      return chips.map((chip: any) => chip.value);
    }

    // Welcome message: use the chips baked in at creation time — never affected by API responses.
    if (message.id === this.welcomeMessageId) {
      return message.content?.metadata?.welcomeChips ?? [];
    }

    // Bot response messages: use API-returned suggestions for the latest message only.
    return (this.activeSuggestions ?? []);
  }

  /**
   * Handle site/context point selection from search component
   * Updates the current context and reinitializes chat
   * 
   * @param $event - Event containing selected search result details
   */
  public getSelectedSiteData($event: any): void {
    this.selectedSearchDetails = $event?.selectedSearchedResult;
    this.contextPointId.set($event?.selectedSearchedResult?.SiteId);
    this.searchResultModal = $event;
    this.initializeChat();
  }

  /**
   * Toggle voice recording on/off
   * Starts recording if not active, stops if active
   */
  toggleRecording(): void {
    if (this.isRecording) {
      this.stopRecording();
    } else {
      this.startRecording();
    }
  }

  /**
   * Trigger the hidden image file input
   */
  triggerImageUpload(): void {
    this.imageInput()?.nativeElement.click();
  }

  /**
   * Handle image file selection
   */
  onImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      // TODO: Implement image upload to backend
      // For now, display the filename in the input
      this.currentMessage = `[Image: ${file.name}]`;
    }
  }

  /**
   * Handle help button click
   */
  onHelpClick(): void {
    // TODO: Implement help functionality (e.g., show help dialog, documentation, or tips)
  }

  /**
   * Clear the selected search/site context
   * Resets context-related state when user clears selection
   * 
   * @param $event - Boolean flag indicating if clear should be executed
   */
  public clearSelection($event: boolean): void {
    if ($event) {
      this.searchResultModal = null;
      this.contextPointId.set(null);
    }
  }

  /**
   * Handle suggestion chip selection
   * Fills the input field with the selected suggestion and sends the message
   * 
   * @param selectedChip - The chip item that was selected
   */
  onChipSelection(selectedChip: IAgentChipList) {
    const value = selectedChip.value;
    if (this.activeFlowAction === 'dismiss' || this.activeFlowAction === 'close' || this.activeFlowAction === 'reviewed' || this.activeFlowAction === 'reassign' || this.activeFlowAction === 'delete') {

      this.addUserMessage(value);

      this.aiAgentService.emitBotFlow({
        source: 'user',
        type: 'chip',
        action: this.activeFlowAction,
        text: value
      });

      return;
    }
    this.currentMessage = value;
    this.sendMessage();
  }



  /**
   * Check microphone permission status
   * @private
   */
  private async checkMicrophonePermission(): Promise<void> {
    if ('navigator' in window && 'permissions' in navigator) {
      try {
        const permission = await navigator.permissions.query({ name: 'microphone' as PermissionName });
        this.microphonePermission = permission.state;

        // Listen for permission changes
        permission.addEventListener('change', () => {
          this.microphonePermission = permission.state;
        });

      } catch (error) {
      }
    }
  }

  /**
   * Request explicit microphone permission from the user
   * @returns Promise resolving to true if granted, false if denied
   * @private
   */
  private async requestMicrophonePermission(): Promise<boolean> {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      // Stop the stream immediately as we only wanted permission
      stream.getTracks().forEach(track => track.stop());
      this.microphonePermission = 'granted';
      return true;
    } catch (error) {
      this.microphonePermission = 'denied';
      this.showPermissionError();
      return false;
    }
  }

  /**
   * Initialize Web Speech API for voice recognition
   * Configures continuous listening mode with real-time transcription
   * @private
   */
  private setupVoiceRecognition(): void {
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;

    if (SpeechRecognition) {
      this.voiceSupported = true;
      this.recognition = new SpeechRecognition();

      // Configure settings for continuous recording
      this.recognition.continuous = true;  // Keep listening continuously
      this.recognition.interimResults = true;  // Show real-time results
      this.recognition.lang = 'en-US';
      this.recognition.maxAlternatives = 1;  // Only need the best result

      // Event handlers - SET ONCE HERE
      this.recognition.onstart = () => {
        this.isRecording = true;
      };

      this.recognition.onresult = (event: any) => {
        let finalTranscript = '';
        let interimTranscript = '';

        // Process all results
        for (let i = event.resultIndex; i < event.results.length; i++) {
          const transcript = event.results[i][0].transcript;

          if (event.results[i].isFinal) {
            finalTranscript += transcript + ' ';
          } else {
            interimTranscript += transcript;
          }
        }

        // Update UI with current speech
        if (finalTranscript) {
          this.currentMessage = (this.currentMessage + finalTranscript).trim();
          this.sendMessage();
        }

        // Show interim results as placeholder only
        if (interimTranscript) {
          this.updatePlaceholderMessage(`Hearing: "${interimTranscript}"`);
        }
      };

      this.recognition.onend = () => {
        // If we're supposed to be recording (user still holding button), restart
        if (this.isRecording) {
          // Restart recognition after a brief pause
          setTimeout(() => {
            if (this.isRecording) {
              try {
                this.recognition.start();
              } catch (error) {
                this.handleSpeechError('restart-failed');
              }
            }
          }, 100);
        } else {
          // User stopped recording - reset to default placeholder
          this.updatePlaceholderMessage('Ask me anything..!');
        }
      };

      this.recognition.onerror = (event: any) => {
        this.isRecording = false;
        // Reset to default placeholder on error
        this.updatePlaceholderMessage('Ask me anything..!');
      };
    } else {
    }
  }

  /**
   * Start voice recording with permission checks
   * Initiates continuous speech recognition
   */
  async startRecording(): Promise<void> {
    if (!this.voiceSupported) {
      alert('Voice recognition not supported in this browser');
      return;
    }

    // If already recording, stop it
    if (this.isRecording) {
      this.recognition.stop();
      return;
    }

    // Check/request permission before starting
    if (this.microphonePermission === 'denied') {
      this.showPermissionError();
      return;
    }

    if (this.microphonePermission === 'prompt') {
      const granted = await this.requestMicrophonePermission();
      if (!granted) return;
    }

    try {
      // Clear previous message if starting fresh
      if (!this.currentMessage.trim()) {
        this.currentMessage = '';
      }

      // Start continuous recognition
      this.recognition.start();
    } catch (error) {
      this.handleSpeechError('start-failed');
    }
  }

  /**
   * Stop voice recording
   * Halts speech recognition and cleans up associated timeouts
   */
  stopRecording() {
    if (this.isRecording) {
      this.isRecording = false; // Set this BEFORE calling stop() so onend knows it was intentional

      // Clear any pending restart timeout
      if (this.recordingTimeout) {
        clearTimeout(this.recordingTimeout);
        this.recordingTimeout = null;
      }

      this.recognition.stop(); // This will trigger onend which resets placeholder
    }
  }

  /**
   * Handle speech recognition errors
   * Provides user-friendly error messages for various failure scenarios
   * 
   * @param error - Error code string
   * @private
   */
  private handleSpeechError(error: string): void {
    let message = '';

    switch (error) {
      case 'not-allowed':
        message = 'Microphone access denied. Please allow microphone permissions in your browser settings.';
        break;
      case 'no-speech':
        message = 'No speech detected. Please speak clearly and try again.';
        break;
      case 'network':
        message = 'Network error occurred. Please check your internet connection.';
        break;
      case 'audio-capture':
        message = 'No microphone found. Please check your audio devices.';
        break;
      case 'start-failed':
        message = 'Failed to start voice recognition. Please try again.';
        break;
      case 'restart-failed':
        message = 'Voice recognition stopped unexpectedly. Please click the microphone again.';
        break;
      default:
        message = 'Voice recognition failed. Please try again.';
    }

    // Show error message to user
    this.addSystemMessage(message, 'error');
  }

  /**
   * Display microphone permission error with instructions
   * @private
   */
  private showPermissionError(): void {
    const message = `
            🎤 Microphone access is required for voice input.
            
            To enable:
            1. Click the microphone icon in your browser's address bar
            2. Select "Always allow" for this site
            3. Try the voice button again
        `;

    this.addSystemMessage(message, 'error');
  }

  /**
   * Update the placeholder message and trigger change detection
   * 
   * @param message - New placeholder text
   * @private
   */
  private updatePlaceholderMessage(message: string): void {
    this.placeHolderMessage = message;
    this.cdr.detectChanges();
  }

  /**
   * Add a system message to the chat (info or error)
   * 
   * @param text - Message content
   * @param type - Message type ('info' or 'error')
   * @private
   */
  private addSystemMessage(text: string, type: 'info' | 'error' = 'info'): void {
    const systemMessage: ChatMessage = {
      id: this.generateId(),
      type: 'bot',
      timestamp: new Date(),
      content: {
        type: 'text',
        data: `${type === 'error' ? '⚠️' : 'ℹ️'} ${text}`
      }
    };
    this.messages.update(msgs => [...msgs, systemMessage]);
    this.scrollToBottom();
  }

  private checkIsMobile(): boolean {
    const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|windows phone/.test(
      navigator.userAgent.toLowerCase()
    );
    const isIpadOS = navigator.maxTouchPoints >= 1 && /macintosh/i.test(navigator.userAgent);
    return isMobileDevice || isIpadOS || window.innerWidth < this.mobileBreakpoint;
  }

  getFullConversation(sessionId: string) {
    this.aiAgentService.getLegionellaConversationBySessionId(sessionId)
      .pipe(takeUntil(merge(this.destroy$, this.cancelActiveRequest$)))
      .subscribe({
        next: (conversation: EvaDciConversation | null) => {
          const chatMessages: ChatMessage[] = (conversation?.Messages ?? []).map((msg: EvaDciMessage) => {
            const isUser = msg.Role === 0;
            return {
              id: msg.MessageId || this.generateId(),
              type: isUser ? 'user' : 'bot',
              timestamp: msg.Timestamp ? new Date(msg.Timestamp) : new Date(),
              content: isUser ?
                { type: 'text', data: msg.Content } :
                getLegionellaResponseContent({ Message: msg.Content })
            };
          });
          this.messages.set(chatMessages);
          this.isLoadingChat.set(false);
          this.scrollToBottom();
        },
        error: (_error: any) => {
          const errorMessage: ChatMessage = {
            id: this.generateId(),
            type: 'bot',
            timestamp: new Date(),
            content: {
              type: 'text',
              data: 'Sorry, I encountered an error while loading the conversation. Please try again.'
            }
          };
          this.messages.update(msgs => [...msgs, errorMessage]);
          this.isLoadingChat.set(false);
          this.scrollToBottom();
        }
      });
  }

  // DCI (Coolant Health IQ) specific conversation retrieval. 
  // This is a temporary solution until the API is unified.
  getCoolantHealthIqFullConversation(sessionId: string) {
    this.aiAgentService.getCoolantHealthIqConversationBySessionId(sessionId)
      .pipe(takeUntil(merge(this.destroy$, this.cancelActiveRequest$)))
      .subscribe({
        next: (conversation: EvaCoolantConversation | null) => {
          const chatMessages: ChatMessage[] = (conversation?.Messages ?? []).map((msg: EvaCoolantMessage) => {
            const isUser = (msg.role ?? '').toLowerCase() === 'user';
            return {
              id: msg.messageId || this.generateId(),
              type: isUser ? 'user' : 'bot',
              timestamp: msg.timestamp ? new Date(msg.timestamp) : new Date(),
              content: isUser ?
                { type: 'text', data: msg.content } :
                getLegionellaResponseContent({ Message: msg.content })
            };
          });
          this.messages.set(chatMessages);
          this.isLoadingChat.set(false);
          this.scrollToBottom();
        },
        error: (_error: any) => {
          const errorMessage: ChatMessage = {
            id: this.generateId(),
            type: 'bot',
            timestamp: new Date(),
            content: {
              type: 'text',
              data: 'Sorry, I encountered an error while loading the conversation. Please try again.'
            }
          };
          this.messages.update(msgs => [...msgs, errorMessage]);
          this.isLoadingChat.set(false);
          this.scrollToBottom();
        }
      });
  }

  /**
   * Start a new chat session
   * Clears current conversation and shows welcome message with suggestions
   */
  startNewChat() {
    // Close the chat history panel if on mobile to focus on the chat
    if (this.isMobile) {
      this.chatFlyout()?.closeRightPanel();
    }
    this.currentMessage = '';
    this.feedbackSelections = {};
    this.initializeChat();
  }

  /**
   * Submit feedback for a bot message
   * 
   * @param messageId - ID of the message being rated
   * @param didUserLike - True if user liked, false if disliked
   */
  sendFeedback(message: ChatMessage, didUserLike: boolean) {
    const selectedFeedback = didUserLike ? 'like' : 'dislike';

    if (this.feedbackSelections[message.id] === selectedFeedback) {
      return;
    }

    this.feedbackSelections = {
      ...this.feedbackSelections,
      [message.id]: selectedFeedback
    };

    const feedbackContext = message.content?.metadata?.feedbackContext ?? this.getFallbackFeedbackContext();
    const feedbackSaveRequest = feedbackContext
      ? this.aiAgentService.buildFeedbackSaveRequest({
        sourceIdentifier: feedbackContext.sourceIdentifier ?? '',
        contextPointId: feedbackContext.contextPointId ?? 0,
        sourceIdentifierTypeId: EVA_FEEDBACK_IDENTIFIER_TYPES.eva,
        sourceIdentifierSubtypeId: EVA_FEEDBACK_IDENTIFIER_SUBTYPES.eva,
        sourceApplicationTypeId: feedbackContext.sourceApplicationTypeId ?? 10
      }, didUserLike ? 1 : 0, message.content?.metadata?.chatId ?? this.chatID ?? undefined)
      : null;

    if (feedbackSaveRequest) {
      this.isLoading = true;
      this.aiAgentService.saveFeedback(feedbackSaveRequest).pipe(takeUntil(this.destroy$)).subscribe({
        next: (success) => {
          this.appendFeedbackAck(
            success
              ? 'Thank you for the feedback! Can I help with anything else?'
              : 'Sorry, I encountered an error while processing your request. Please try again.'
          );
        },
        error: () => {
          this.appendFeedbackAck('Sorry, I encountered an error while processing your request. Please try again.');
        }
      });
    } else {
      this.appendFeedbackAck('Thank you for the feedback! Can I help with anything else?');
    }
  }

  getSelectedFeedback(messageId: string): 'like' | 'dislike' | null {
    return this.feedbackSelections[messageId] ?? null;
  }

  private buildResponseMetadata(
    response: EvaResponse | null,
    parsedResponse: ChatContent
  ) {
    const activePageId =
      response?.ActivePageId
      ?? this.aiAgentService.nextPromtDetails?.activeContext?.contextPoints?.[0]?.contextPointId
      ?? parsedResponse.metadata?.activePageId
      ?? (this.contextPointId ? String(this.contextPointId) : undefined)

    const resolvedContextPointId = this.toPositiveNumber(activePageId);

    const sourceIdentifier = this.resolveFeedbackSourceIdentifier(
      response,
      parsedResponse
    );

    const allUserSiteIds =
      response?.AllUserSiteIds?.length
        ? response.AllUserSiteIds
        : this.aiAgentService.nextPromtDetails?.activeContext?.contextPoints?.length
          ? this.aiAgentService.nextPromtDetails.activeContext.contextPoints.map(
            cp => cp.contextPointId
          )
          : resolvedContextPointId
            ? [String(resolvedContextPointId)]
            : parsedResponse.metadata?.allUserSiteIds;

    return {
      ...(parsedResponse.metadata ?? {}),
      chatId:
        response?.ChatId
        ?? this.chatID
        ?? this.aiAgentService.nextPromtDetails?.chatId
        ?? parsedResponse.metadata?.chatId,
      activePageId,
      allUserSiteIds,
      feedbackContext:
        sourceIdentifier && resolvedContextPointId
          ? {
            sourceIdentifier,
            contextPointId: resolvedContextPointId,
            sourceIdentifierTypeId: EVA_FEEDBACK_IDENTIFIER_TYPES.eva,
            sourceIdentifierSubtypeId: EVA_FEEDBACK_IDENTIFIER_SUBTYPES.eva,
            sourceApplicationTypeId:
              parsedResponse.metadata?.feedbackContext?.sourceApplicationTypeId ?? 10
          }
          : parsedResponse.metadata?.feedbackContext
    };
  }

  private getFallbackFeedbackContext() {
    const sourceIdentifier = this.resolveFeedbackSourceIdentifier(
      null,
      { type: 'text', data: '', metadata: undefined }
    );

    const contextPointId = this.toPositiveNumber(
      this.aiAgentService.nextPromtDetails?.activeContext?.contextPoints?.[0]?.contextPointId
      ?? (this.contextPointId ? String(this.contextPointId) : undefined)
    );

    if (!sourceIdentifier || !contextPointId) {
      return null;
    }

    return {
      sourceIdentifier,
      contextPointId,
      sourceIdentifierTypeId: EVA_FEEDBACK_IDENTIFIER_TYPES.eva,
      sourceIdentifierSubtypeId: EVA_FEEDBACK_IDENTIFIER_SUBTYPES.eva,
      sourceApplicationTypeId: 10
    };
  }

  private resolveFeedbackSourceIdentifier(
    response: EvaResponse | null,
    parsedResponse: ChatContent
  ): string | undefined {
    const resolvedSourceIdentifier =
      response?.ActiveContext?.ai_generated_insights_id
      ?? this.aiAgentService.nextPromtDetails?.activeContext?.intelligenceid
      ?? this.aiAgentService.nextPromtDetails?.activeContext?.sourceIdentifier?.primaryId
      ?? parsedResponse.metadata?.feedbackContext?.sourceIdentifier
      ?? (this.contextPointId ? String(this.contextPointId) : undefined);

    return `${resolvedSourceIdentifier ?? ''}`.trim()
      ? String(resolvedSourceIdentifier)
      : undefined;
  }

  private appendFeedbackAck(text: string): void {
    this.isLoading = false;
    const ackMessage: ChatMessage = {
      id: this.generateId(),
      type: 'bot',
      timestamp: new Date(),
      content: {
        type: 'text',
        data: text,
        metadata: { isFeedbackAck: true }
      }
    };
    this.messages.update(msgs => [...msgs, ackMessage]);
    this.scrollToBottom();
  }

  private toPositiveNumber(value: unknown): number | undefined {
    const parsedValue = Number(value);

    return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : undefined;
  }

  @HostListener('window:eva-mfe-toggle')
  onEvaMfeToggle(): void {
    this.openAIAgent();
  }

  /**
   * Toggle AI agent flyout visibility
   */
  openAIAgent() {
    if (this.showAIAgent && !this.isEvaCollapsed) {
      this.aiAgentService.setEvaState({ show: true, collapsed: true });
    } else {
      this.aiAgentService.setEvaState({ show: true, collapsed: false });
    }
  }

  onFlyoutWidthChange(widthPercent: number): void {
    if (!this.showAIAgent || this.isEvaCollapsed) {
      return;
    }

    const minWidth = 20;
    const maxWidth = 80;
    const resolvedWidth = Math.min(maxWidth, Math.max(minWidth, widthPercent));

    this.flyOutWidthPercentage.set(resolvedWidth);
    window.dispatchEvent(new CustomEvent('eva-mfe-width', { detail: { widthPercent: resolvedWidth } }));
  }

  /**
   * Save the edited message and resend to get new response
   * Removes both the user message and subsequent bot response before resending
   */
  saveEditedMessage(): void {
    if (!this.editMessageId || !this.editingMessage.trim()) {
      return;
    }

    // Find the index of the message being edited
    const currentMessages = this.messages();
    const messageIndex = currentMessages.findIndex(msg => msg.id === this.editMessageId);
    if (messageIndex === -1) {
      return;
    }

    // Remove the user message and the next bot message (if it exists)
    const messagesToRemove = 1; // Remove the user message
    let removeCount = messagesToRemove;

    // Check if there's a bot message immediately after this user message
    if (messageIndex + 1 < currentMessages.length &&
      currentMessages[messageIndex + 1].type === 'bot') {
      removeCount = 2; // Remove both user and bot message
    }

    // Remove the messages by creating a new array without them
    const newMessages = [...currentMessages];
    newMessages.splice(messageIndex, removeCount);
    this.messages.set(newMessages);

    // Create new user message with edited content
    // const newUserMessage: ChatMessage = {
    //   id: this.editMessageId,
    //   type: 'user',
    //   timestamp: new Date(),
    //   content: {
    //     type: 'text',
    //     data: this.editingMessage.trim()
    //   }
    // };

    // Insert the new message at the same position
    // this.messages.splice(messageIndex, 0, newUserMessage);



    // Send the new message to get a fresh response
    this.currentMessage = this.editingMessage.trim();
    this.sendMessage(this.editMessageId);

    // Reset edit state
    this.cancelEdit();
  }

  /**
   * Cancel message edit mode without saving changes
   */
  cancelEdit(): void {
    this.editMessageId = null;
    this.editingMessage = '';
  }

  /**
   * Handle chat history selection from flyout
   * Sets the chat ID to continue an existing conversation
   * 
   * @param historyItem - Selected chat history item
   */
  onChatHistorySelected(historyItem: any): void {
    if (this.isMobile) {
      this.chatFlyout()?.closeRightPanel();
    }
    this.resetActiveRequestState();
    // Set the chatID to continue the existing conversation
    this.chatID = historyItem?.id;
    this.isLoadingChat.set(true);
    this.enableChatStreaming = false;

    // DCI (Legionella Dashboard) specific flow: if the current route is for Legionella Test Results,
    // use a different API endpoint and payload structure.
    // P.S. Will be removed once API for DCI (Legionella Dashboard) is unified in BED.
    if (this.isLegionellaTestResultsRoute()) {
      this.getFullConversation(historyItem?.id);
      return;
    }

    // DCI (Coolant Health IQ Dashboard) specific flow: if the current route is for Coolant Health IQ,
    // use a different API endpoint and payload structure.
    // This is a temporary solution until the API is unified.
    if (this.isCoolantHealthIqRoute()) {
      this.getCoolantHealthIqFullConversation(historyItem?.id);
      return;
    }

    this.getContexPointDetails(historyItem?.ContextIdentifier?.Value);

    // Chat history service method is unavailable in AIAgentService.
    // Intentionally skip loading old history and keep current flow as no-op.
    this.isLoadingChat.set(false);
  }

  /**
   * Close the AI agent flyout panel
   * 
   * @param showAIAgent - New visibility state
   */
  public closeAgentFlyout(showAIAgent: boolean): void {
    this.showAIAgent = showAIAgent;
    if (!showAIAgent) {
      this.aiAgentService.setEvaState({ show: false, collapsed: false });
    }
  }

  /**
   * Get context point (site) details
   * Retrieves or uses cached site information for the conversation context
   * 
   * @param contextPointID - ID of the context point to load
   */
  getContexPointDetails(contextPointID: string) {
    // Check if we already have this context point cached
    if (this.contextPointCache[contextPointID]) {

      // Use cached data
      setTimeout(() => {
        this.searchInputData.SearchTabs[1].activeData = {
          contextPointId: this.contextPointCache[contextPointID].contextPointId,
          contextPointName: this.contextPointCache[contextPointID].siteName,
          selectionHierarchy: [],
        };
        this.selectedSearchDetails.Site = this.contextPointCache[contextPointID].siteName;
        this.contextPointId.set(this.contextPointCache[contextPointID].contextPointId);
      }, 0);

      return; // Exit early, no API call needed
    }

    // Site lookup service method is unavailable in AIAgentService.
    // Intentionally skip enrichment and keep only the bare context point id.
    this.contextPointId.set(Number(contextPointID));
    this.isLoadingChat.set(false);
  }

  /**
   * Clear the context point cache
   * Called during component cleanup
   */
  clearContextPointCache(): void {
    this.contextPointCache = {};
  }

  /**
   * Cancel any in-flight request and reset loading indicator
   */
  private resetActiveRequestState(): void {
    this.cancelActiveRequest$.next();
    this.isLoading = false;
    this.isLoadingChat.set(false);
    this.sendingRequest = false;
  }

  /**
   * Handle right panel toggle event
   * Loads chat history when the right panel is opened
   * 
   * @param showRightPanel - True if right panel is now visible
   */
  onToggleRightPanel(showRightPanel: boolean) {
    if (showRightPanel) {
      this.chatHistoryList()?.getChatHistoryList();
    }
  }

}
